import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import ToastInfo from "../../../../Toasts/ToastInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { BorderedTextInput } from "../../../../HouseStyle/Components/Inputs";
import { ButtonBlue, ButtonLightGrey } from "../../../../HouseStyle/Components/Buttons";

const SecurityCodeModal = ({ show, onHide, securityCode, setSecurityCode, updateUser }) => {
  const [localCode, setLocalCode] = useState(securityCode);

  useEffect(() => {
    setLocalCode(securityCode);
  }, [securityCode, show]);

  const handleSave = () => {
    setSecurityCode(localCode);
    updateUser(localCode);
    onHide();
  };

  const handleGenerate = async (e) => {
    e.preventDefault();
    const length = 4;
    const charset = "0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset[randomIndex];
    }
    setLocalCode(code);
    try {
      await navigator.clipboard.writeText(code);
      ToastInfo(
        "Pincode gekopieerd naar clipboard. Vergeet niet je pincode ergens op te slaan in bijvoorbeeld een passwordmanager.",
        'Pincode_copied',
        7500
      );
    } catch (err) {
      console.error("Failed to copy pincode: ", err);
    }
  };

  return (
    <Modal
      id="modalBlueprint"
      className="passModal"
      show={show}
      onHide={onHide}
      size="lg"
      centered
    >
      <Modal.Header className="modalTop modalChangePassword">
        <div className="d-flex flex-row justify-content-between w-100">
          <h3 className="ms-3 text-nowrap fw-semibold">Pincode wijzigen</h3>
          <button className="btn" onClick={onHide}>
            <FontAwesomeIcon className="closeModal" icon={faXmark} />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="modalContent pt-0">
        <div className="innerBox d-flex flex-column gap-2">
          <div className="d-flex flex-column gap-4">
            <BorderedTextInput
              label="Nieuwe pincode"
              size="l"
              inputValue={localCode || ""}
              setInputValue={value => setLocalCode(value.replace(/\D/g, '').slice(0, 4))}
              maxLength={4}
              placeholder="Nieuwe pincode"
            />
          </div>
          <p className="small text-muted mt-2">De pincode kan worden gebruikt als snelle inlogmethode in plaats van wachtwoord.<br />Je kunt het gebruiken in POS apparaten, de POS App, InStore en InControl.</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="modalBottom px-2">
        <div className="mx-3 my-0">
            <div className="d-flex gap-2 w-100">
                <ButtonLightGrey
                    size="s"
                    text={"Willekeurig pincode"}
                    onClickFunction={handleGenerate}
                />
                <ButtonBlue
                    size="l"
                    text={"Wijzig pincode"}
                    onClickFunction={handleSave}
                />
            </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SecurityCodeModal;